import { EventType } from '@/analytics/types';

import { NewYearHeroBackground } from './common/NewYearHeroBackground';
import HolidayHeroTemplate25 from './HolidayHeroTemplate25';

const NewYearHealthHero = () => {
  return (
    <HolidayHeroTemplate25
      Background={NewYearHeroBackground}
      titleMsgKey="new_year_hero_health_title"
      subcopyMsgKey="new_year_hero_copy"
      buttonProps={{
        href: '/store',
        ctaLabel: 'call_to_action_button_text',
        onClick: () => {
          void window.ouraAnalytics.track(EventType.CTAClicked, {
            cta: 'shop now',
            action: 'go to store',
            location: 'home hero',
            path: '/store',
          });
        },
      }}
      dataCy="new-year-health-hero"
    />
  );
};

export default NewYearHealthHero;
